import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import type { DropzoneRootProps } from 'react-dropzone';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import EditIcon from '@wix/da-ds/pkg/Icons/24x24/Edit';

import s from './ReplacePreviewImageButton.scss';

export interface ReplacePreviewImageButtonProps {
  /** Hidden file input; omit when preview must be chosen via need-preview dropzone only */
  previewFileInput: React.ReactNode | null;
  className?: string;
  allowUpload: boolean;
  needsPreview: boolean;
  getDropzoneRootProps: () => DropzoneRootProps;
}

const ReplacePreviewImageButton: React.FC<ReplacePreviewImageButtonProps> = ({
  previewFileInput,
  className,
  allowUpload,
  needsPreview,
  getDropzoneRootProps,
}) => {
  const { t } = useTranslation();
  const tooltip = t('deviationSubmit.form.preview.replace.tooltip.text');

  return (
    <>
      {previewFileInput}
      <div className={className} {...(allowUpload && !needsPreview ? getDropzoneRootProps() : {})}>
        <IconButton
          className={cn(s['edit-btn'], (!allowUpload || needsPreview) && s['disabled'])}
          size={'small'}
          icon={EditIcon}
          disabled={!allowUpload || needsPreview}
          tooltipOffset={[0, 8]}
          tooltipText={allowUpload ? tooltip : undefined}
          aria-label={tooltip}
        />
      </div>
    </>
  );
};
ReplacePreviewImageButton.displayName = 'ReplacePreviewImageButton';

export default ReplacePreviewImageButton;
